<template>
  <div id="app">
    <div class="spiner-postion hide">
      <div class="sk-spinner sk-spinner-double-bounce">
        <div class="sk-double-bounce1"></div>
        <div class="sk-double-bounce2"></div>
      </div>
    </div>
    <div class="spiner-postion2 hide">
      <div class="sk-spinner sk-spinner-double-bounce">
        <div class="sk-double-bounce1"></div>
        <div class="sk-double-bounce2"></div>
      </div>
    </div>
    <warningdlg>
      <button
        v-for="(item,index) in $store.state.warning.button"
        :key="index"
        type="button"
        :id="true?item.name:''"
        class="btn btn-block btn-primary"
        @click="item.callBack"
      >{{item.name}}</button>
    </warningdlg>
    <magazinedlg :rnd="$store.state.magazine.rnd">
    </magazinedlg>
    <router-view />
  </div>
</template>
<script>
import warningDlg from "./components/common/warningDlg";
import magazinePreviewDlg from "./components/common/magazinePreviewDlg";
import eventBus from "./eventbus";

import 'bootstrap-icons/font/bootstrap-icons.css';

export default {
  name: "app",
  components: {
    warningdlg: warningDlg,
    magazinedlg:magazinePreviewDlg
  },
  methods: {
    warningBtn(data) {
      eventBus.$emit("warningBtn", data);
    }
  }
};
</script>

